import { get, isNil, isUndefined, omitBy } from "lodash";

const QUERY_STRING_PREFIX = "?";

export const parseQueryString = (query: string): QueryParams => {
  const validQuery = decodeURI(query).trim();
  if (!validQuery) {
    return {};
  }

  const queryPrefix = validQuery.slice(0, 1);
  if (queryPrefix !== QUERY_STRING_PREFIX) {
    console.error("Query string format is not correct");
    return {};
  }
  const queryStringParams = validQuery
    .slice(1)
    .split("&")
    .map((param) => {
      const paramObj = {} as any;
      const result = param.split("=");
      const key = result[0];
      const value = result[1];
      if (!key || !value) {
        return {};
      }
      paramObj[result[0]] = result[1];
      return paramObj;
    })
    .reduce((params, currentParams) => ({ ...currentParams, ...params }));
  return omitBy(queryStringParams, isUndefined);
};

export type QueryParams = { [P in string]?: string };

export const generateQueryString = (queryParams: {
  [P in string]?: string | null | number;
}) => {
  const params = omitBy(queryParams, isInvalidParams);
  const paramsArray = Object.keys(params).map(
    (key) => `${key}=${get(params, key)}`
  );
  return encodeURI(paramsArray.join("&"));
};

const isInvalidParams = (value: any) => {
  const valueType = typeof value;
  return (
    valueType === "function" ||
    valueType === "object" ||
    isNil(value) ||
    value === ""
  );
};
